import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./configureStore";
import { getLanguages, getToken } from "./services/Connector";
import { OpenUrl } from "./services/SSO";

const store = configureStore();
OpenUrl("https://api.textunited.com/jsoneditor/auth/login?ReturnUrl=https://textunited.com/po-free-translator/&?checkOnly=Y");


// getToken().then((response) => {
//       sessionStorage.setItem("refresh_token", response.data.refreshToken);
//       sessionStorage.setItem("token", response.data.accessToken);
//     }
//   );
store.dispatch(getLanguages());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
